export const ATTRIBUTES = {
  STANDARD_CODE: 'ID del Estándar',
  STATUS: 'Estado',
  OWNER: 'Responsable',
  STANDARDS: 'Estándares',
  EXTERNAL_LINKS: 'Enlaces Externos',
  CLUSTER: 'Cluster',
  CLUSTERS: 'Clusters',
  DEADLINE: 'Fecha Límite',
  CREATED_AT: 'Fecha de Creación',
  RELATED_CONTROL: 'Control Relacionado',
}
export const EXTERNAL_LINKS = 'Enlaces Externos'
export const FILES = 'Archivos'
export const NO_NAME = 'Sin Nombre'
